var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'select-input',
		{
			'select-input--label': _vm.label,
			'select-input__full': _vm.inputFull,
			'select-input__big': _vm.bigSize,
		},
	]},[_vm._v(" "+_vm._s(_vm.label)+" "),(!_vm.label)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectModel),expression:"selectModel"}],class:[
			'select-input__select',
			{
				'select-input__select__big': _vm.bigSize,
			},
		],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectModel=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.selectChange],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')}}},_vm._l((_vm.selectList),function(item){return _c('option',{key:item.value,domProps:{"value":item.value}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0):_vm._e(),(_vm.usePeriod)?_c('date-range',{ref:"period",class:[
			'select-input__period',
			{
				'select-input__period--label': _vm.label,
			},
		],attrs:{"value":{ from: _vm.from, to: _vm.to },"type":"date"},on:{"input":_vm.changePeriod,"enter":function($event){return _vm.$emit('enter')}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputModel),expression:"inputModel"}],class:[
			'select-input__input',
			{
				'select-input__input--label': _vm.label,
				'select-input__input__big': _vm.bigSize,
			},
		],attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.inputModel)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')},"input":[function($event){if($event.target.composing)return;_vm.inputModel=$event.target.value},_vm.inputInput]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }